import {
  Component,
  input,
  model,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Bind } from 'primeng/bind';
import { Dialog } from 'primeng/dialog';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Button } from 'primeng/button';

@Component({
  selector: 'ag-discard-confirmation-modal',
  templateUrl: './discard-confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Dialog, AngularSvgIconModule, Button],
})
export class DiscardConfirmationModalComponent {
  visible = model<boolean>(false);
  title = input.required<string>();
  body = input.required<string>();

  readonly acceptButtonLabel = 'Yes, exit page';
  readonly cancelButtonLabel = 'Cancel';

  confirmed = output<void>();
  cancelled = output<void>();

  onConfirm(): void {
    this.confirmed.emit();
    this.visible.set(false);
  }

  onCancel(): void {
    this.cancelled.emit();
    this.visible.set(false);
  }
}
